import { motion } from 'framer-motion';
import React, {JSX, useEffect, useState} from 'react';
import Modal from 'react-modal';

interface SlotInfoCardProps {
    rtp: number; // Return to Player percentage
    symbols: string[]; // Array of symbol image URLs
    title: string; // Slot title
}

export function SlotInfoCardComponent({ rtp, symbols, title }: SlotInfoCardProps): JSX.Element {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const openModal = (image: string) => {
        document.body.style.overflowY = 'hidden';
        setSelectedImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        document.body.style.overflowY = 'auto';
        setSelectedImage(null);
        setIsModalOpen(false);
    };

    useEffect(() => {
        return () => {
            document.body.style.overflowY = 'auto'; // Cleanup on unmount
        };
    }, []);

    return (
        <motion.div
            className="bg-black bg-opacity-50 rounded-lg p-4 text-white w-full mx-auto flex flex-col gap-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
        >
            {/* Symbols Section */}
            <div className="flex flex-wrap justify-center gap-2">
                {symbols.map((symbol, index) => (
                    <img
                        key={index}
                        src={symbol}
                        alt={`Symbol ${index + 1}`}
                        className="md:max-h-52 max-h-28 object-contain w-md m-auto md:hover:saturate-150 md:saturate-0 transition-[filter]  cursor-pointer"
                        onClick={() => openModal(symbol)}
                    />
                ))}
            </div>

            {/* Modal for Fullscreen Image */}
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Image Modal"
                className="flex justify-center items-center bg-black bg-opacity-50 fixed inset-0"
                overlayClassName="fixed inset-0 bg-black bg-opacity-75"
            >
                {selectedImage && (
                    <img
                        src={selectedImage}
                        alt="Fullscreen Symbol"
                        className="max-w-full max-h-full object-contain"
                        onClick={closeModal}
                    />
                )}
                <button
                    onClick={closeModal}
                    className="absolute top-20 right-4 text-white text-4xl"
                >
                    &times;
                </button>
            </Modal>
        </motion.div>
    );
}
